import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class BiginsightsWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.biginsights.ID;
		this.name = DatabaseEnum.biginsights.NAME;
		this.code = DatabaseEnum.biginsights.CODE;
		this.conn_DbsTabName = 'Schemas';
		this.showSettingsTab = true;
		this.showHdfsSettingsTab = true;
		this.hideSchemaNmColumn = false;
		this.hideDatabaseNmDbColumn = true;
		this.showRepConnServiceNm = true;
    this.showDataDescription = false;
		this.dataObjectConnDatabaseNm = 'Schema';
		this.equivalentTag = 'bsid';
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {

		if (repConnWrapper.repConn.conn.host == "") {
			repConnWrapper.inValid_Cds.push('NO_HOST');
		}

		if (repConnWrapper.repConn.conn.port == "") {
			repConnWrapper.inValid_Cds.push('NO_PORT');
		}

		if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
			repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
		}

		if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
			repConnWrapper.inValid_Cds.push('NO_PASSWORD');
		}

		if (repConnWrapper.repConn.conn_Dbs.length != 0) {
			if (repConnWrapper.repConn.conn_Dbs[0].databaseNm == "") {
				repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
			}
		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn_Dbs.length < 1) {
			repConnWrapper.inValid_Cds.push('NO_DATABASE');
		}
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,component: any = null): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDistKeyFlag(objectWrapper, "Part"),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
			this.attributeTabulator.getAttrExprVal(objectWrapper, component),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.lAttributeTabulator.getSrt_Order(),
			this.lAttributeTabulator.getLAttr_Id(),
			this.lAttributeTabulator.getLAttrNm(objectWrapper),
			this.lAttributeTabulator.getSelectColumn(objectWrapper),
			this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
			this.lAttributeTabulator.getLAttrPrec(objectWrapper),
			this.lAttributeTabulator.getLAttrScale(objectWrapper),
			this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
			this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component, "Part"),
		]
	}


	// getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
	//     return [
	//         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
	//         this.lAttributeTabulator.getSrt_Order(),
	//         this.lAttributeTabulator.getLAttr_Id(),
	//         this.lAttributeTabulator.getLAttrNm(objectWrapper),
	//         this.lAttributeTabulator.getSelectColumn(objectWrapper),
	//         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
	//         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
	//         this.lAttributeTabulator.getLAttrScale(objectWrapper),
	//         this.lAttributeTabulator.getLAttrType( objectWrapper ),
	//         this.lAttributeTabulator.getLAttrFunction( objectWrapper),
	//         this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
	//         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
	//         this.lAttributeTabulator.getPartFlag(objectWrapper),
	//         this.lAttributeTabulator.getOrderBy(objectWrapper)
	//     ]
	// }

	getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isMax: boolean = false, isEncryptedFlag: boolean = false, component: any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getDistKeyFlag(objectWrapper, "Part"),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}
}
